<div
  class="slider"
  [ngClass]="{'slider--disabled': disabled, 'slider--readonly': readonly}"
>

  <ng-container *ngIf="label">
    <div class="slider__label">
      {{ label }}
      <ng-container *ngIf="showAdvice">
        <div class="slider__advice-bubble">
          <mfp-bubble
            size="small"
            color="dark"
            label="i"
          ></mfp-bubble>
          <div class="slider__advice-popup mfp-white-box">
            <ng-content select="[adviceContent]"></ng-content>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <div
    class="slider__value"
    [ngClass]="{
      'slider__value--bottom': showValue && valueLabelPosition === 'bottom',
      'slider__value--right': showValue && valueLabelPosition === 'right'
    }"
  >
    <ng-container *ngIf="!loading">
      <div class="input-container">
        <ng-container *ngIf="showValue && valueLabelPosition === 'bottom'">
          <div
            #bottomValueLabelContainer
            class="slider__value-container"
            [style.left]="'clamp(' + valueLabelSafetyPixels + 'px,' + getValuePercentage() + '%, 100% - ' + valueLabelSafetyPixels + 'px)'"
          >
            <mfp-amount-currency>
              <div amount class="slider__value-label">
                {{ value | configCurrency }}
              </div>
              <div currency class="slider__value-aux-label">
                {{ valueAuxLabel }}
              </div>
            </mfp-amount-currency>
          </div>
        </ng-container>
        <input
          type="range"
          [id]="id"
          [name]="name"
          [min]="smoothMin"
          [max]="smoothMax"
          [disabled]="disabled || readonly"
          [required]="required"
          [readonly]="readonly"
          [(ngModel)]="value"
          [ngStyle]="{'background-size': getValuePercentage() + '% 100%'}"
          (click)="changeCoverageInput()"
        >
      </div>
      <ng-container *ngIf="showValue && valueLabelPosition === 'right'">
        <div
          class="slider__value-container"
          [ngStyle]="{'min-width': (valueLabelSafetyPixels + rightValueLabelMinWidthPixels) + 'px'}"
        >
          <div class="slider__value-label">
            {{ value | configCurrency }}
          </div>
          <div class="slider__value-aux-label">
            {{ valueAuxLabel }}
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="loading">
      <div class="slider__skeleton-box">

      </div>
    </ng-container>
  </div>
</div>
